import { render } from "./PlaceHolder.vue?vue&type=template&id=f4b3fc28"
import script from "./PlaceHolder.vue?vue&type=script&lang=js"
export * from "./PlaceHolder.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__